import clsx from "clsx";
import styled from "styled-components";

import { Box } from "~/components/Elements";
import { Text, TextProps } from "~/components/Text";
import * as Bulma from "~/types/bulma";

export const Container = styled.div.attrs({ className: clsx("table-container") })``;

export type TableProps = { bordered?: boolean; striped?: boolean; hoverable?: boolean } & Bulma.Expandable &
  Bulma.Narrowable;

export const Table = styled.table.attrs<TableProps>((props) => ({
  className: clsx({
    [`table`]: true,
    [`is-narrow`]: props.narrow,
    [`is-bordered`]: props.bordered,
    [`is-striped`]: props.striped,
    [`is-hoverable`]: props.hoverable,
    [`is-fullwidth`]: props.fullwidth,
  }),
}))<TableProps>`
  /* table-layout: fixed; */

  border-collapse: separate;
  border-spacing: 0 calc(0.75em * 1);
`;

type ColGroupProps = React.HTMLProps<HTMLTableColElement> & {
  spans: number[];
};
export function ColGroup({ spans, ...props }: ColGroupProps) {
  const cols = spans.reduce((acc, n) => acc + n, 0);
  return (
    <colgroup {...props} span={cols}>
      {spans.map((n, i) => (
        <col key={i} span={1} style={{ width: `${(n / cols) * 100}%` }} />
      ))}
    </colgroup>
  );
}

export const THead = styled.thead``;
export const THR = styled.tr``;

export const TH = styled(Text as "th").attrs<TextProps>({
  as: "th",
})<TextProps>`
  &&& {
    vertical-align: middle;
    padding: 0 calc(0.75em * 1);

    &:first-child {
      padding-left: calc(0.75em * 2);
    }
    &:last-child {
      padding-right: calc(0.75em * 2);
    }
  }
`;
TH.defaultProps = {
  transform: "uppercase",
  color: "grey-dark",
  size: "7",
};

export const TBody = styled.tbody``;
export const TR = styled(Box).attrs({
  as: "tr",
})`
  display: table-row;
  box-shadow: inset 0px 0px 2px 0px #00000040;
`;

export const TD = styled.td`
  &&& {
    vertical-align: middle;
    padding: calc(0.6em * 1) calc(1em * 0.5);

    &:first-child {
      padding-left: calc(0.75em * 1);
    }
    &:last-child {
      padding-right: calc(0.75em * 1);
    }
  }
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
`;

export const TFoot = styled.tfoot``;
